import { CheckInDto } from '@careapp-group/ng-sdk-v2-new';
import { ORGANISATION_CONTEXT_SWITCH, OrganisationContextSwitch } from '../actions/meta.actions';
import { CaEntityReducer } from '../entity-state/entity-reducer';
import { BaseFilterType } from '../entity-state/entity-actions-factory';
import { Action, createReducer, on } from '@ngrx/store';
import { CheckIns } from './check-ins.actions';
import { mergeReducers } from '../entity-state/merge-reducers';

export class CheckInsReducer extends CaEntityReducer<CheckInDto, BaseFilterType> {
  feedbackReducer = createReducer(
    this.initialState,
    on(CheckIns.RequestCheckInsForCustomer, (state, { customerId }) => ({
      ...state,
      loadingAll: true,
    })),
    on(OrganisationContextSwitch, () => this.initialState)
  );

  public reducer(state, action) {
    return this.combinedReducer(state, action);
  }

  public combinedReducer = mergeReducers(this.feedbackReducer, this.entityReducer);
}

export const state = new CheckInsReducer(CheckIns);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
